<template>
	<ul class="input-split list-unstyled">
		<li v-for="item of sortedSplit" :key="item.share.id" :class="{'removed':item.removed}" v-bind:title="item.title">
			<div v-if="showCheckbox" class="form-check">
				<label class="form-check-label">
					<input type="checkbox" class="form-check-input"
						   v-on:change="toggleSplit($event, item.share)"
						   v-bind:checked="item.share.value" checked="checked"
						   v-bind:disabled="disabled"/>
					{{sheet.getBooker(item.share.id).name}}
				</label>
			</div>
			<div v-else class="text-right">{{sheet.getBooker(item.share.id).name}}</div>
			<span>×</span>
			<div>
				<input type="number" step="0.1" min="0" required class="form-control"
				       v-model.number="item.share.value" v-bind:disabled="disabled"/>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			split: Array,
			sheet: Object,
			disabled: {type: Boolean, default: false},
			showCheckbox: {type: Boolean, default: true}
		},

		computed: {
			sortedSplit: function() {
				const bookersIds = new Set(this.sheet.bookersIds());
				return this.split.sort((shareA, shareB) => {
					return this.sheet.getBooker(shareA.id).name.localeCompare(
							this.sheet.getBooker(shareB.id).name);
				}).map(share => {
					const removed = !bookersIds.has(share.id);
					return ({ share, removed, title: removed ? this.$formatMessage('expense_split_sheeter_deleted') : ''});
				});
			}
		},

		methods: {
			toggleSplit($event, part) {
				part.value = Number($event.target.checked);
			}
		}
	}
</script>

<style lang="scss">
	ul.input-split {
		display: table;
		width: 100%;
		margin: 0;

		li {
			display: table-row;

			> * {
				display: table-cell !important;
				margin: 0;
				// for input
				vertical-align: middle;
				line-height: 3rem;
			}

			> div:first-child {
				width: 50%;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 0;
			}

			span {
				min-width: 2rem;
				text-align: center;
			}

			input[type=checkbox] {
				margin-top: 1rem;
				left: 0;
				margin-left: 0;
			}

			input[type=number] {
				min-width: 5rem;
			}

			label {
				display: block;
				margin: 0;
				width: 100%;
				max-width: 11rem;
				text-align: right;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			&.removed label {
				text-decoration: line-through;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/ui/widgets/input-split.vue